/**
 * Ekran izveštaja gostiju u novoj ljusci: nasleđuje stari tab (`base`), pa učitavanje, štampa i
 * Excel ostaju isti, a prikaz je novi (`view`). Ekran je samo posrednik: podatke starog taba daje
 * prikazu kroz svojstva (`viewProps`), a događaje prikaza prosleđuje ljusci (brojke, panel, poruke).
 *
 * @param {object} options
 * @param {string} options.name
 * @param {object} options.base          stari tab (restoran ili admin)
 * @param {object} options.view          komponenta prikaza
 * @param {(vm: object) => object} [options.viewProps]  svojstva prikaza iz stanja starog taba
 * @param {(vm: object) => object} [options.viewOn]     dodatni događaji prikaza
 * @param {object[]} [options.mixins]
 * @param {object} [options.panel]         komponenta detalja narudžbe (podrazumevano panel sa desne strane)
 * @param {boolean} [options.loadOnMount]  stari admin tabovi uče tek kad se promeni period ili izbor
 *                                         restorana, pa ovde učitavaju i pri otvaranju
 */
export const createGuestScreen = ({
  name,
  base,
  view,
  viewProps = () => ({}),
  viewOn = () => ({}),
  mixins = [],
  panel = null,
  loadOnMount = false,
}) => ({
  name,
  panelComponent: panel,
  extends: base,
  mixins,
  watch: {
    isLoading(loading) {
      this.$emit("loading", loading);
    },
  },
  mounted() {
    if (loadOnMount && this.restaurantIds) {
      this.loadData();
    }
  },
  render(h) {
    return h(view, {
      props: { loading: this.isLoading, search: this.searchQuery, ...viewProps(this) },
      on: {
        kpis: (kpis) => this.$emit("kpis", kpis),
        toast: (...args) => this.$emit("toast", ...args),
        ...viewOn(this),
      },
    });
  },
});
